module.exports = __webpack_public_path__ + "static/media/vandal.3a864082.png";